import { render } from "./ComposeMailDrawer.vue?vue&type=template&id=1b4509c4&scoped=true"
import script from "./ComposeMailDrawer.vue?vue&type=script&lang=js"
export * from "./ComposeMailDrawer.vue?vue&type=script&lang=js"

import "./ComposeMailDrawer.vue?vue&type=style&index=0&id=1b4509c4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4509c4"]])

export default __exports__